import { render, staticRenderFns } from "./TheSearchModal.vue?vue&type=template&id=bef7bfa6&"
import script from "./TheSearchModal.vue?vue&type=script&lang=js&"
export * from "./TheSearchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheSearchModal.vue"
export default component.exports